import PaymentIndicator from './PaymentIndicator';

export default PaymentIndicator;
